import type { Breadcrumb } from '@frontend/libs/types/common'

import { BreadcrumbItem, Breadcrumbs } from '@nextui-org/react'
import { Link } from 'react-router-dom'

export function ProductBreadcrumb({
  breadcrumbs,
}: Readonly<{ breadcrumbs: Breadcrumb[] }>) {
  return (
    <Breadcrumbs
      itemClasses={{
        item: 'uppercase',
      }}
      separator="/"
    >
      {breadcrumbs.map((item) => (
        <BreadcrumbItem key={item.id}>
          <Link to={item.url}>{item.text}</Link>
        </BreadcrumbItem>
      ))}
    </Breadcrumbs>
  )
}
